import apiClient from '../utils/apiClient';

// Uploads are multipart — let the browser/axios set the boundary by not
// forcing the apiClient default application/json content type.
const multipart = { headers: { 'Content-Type': 'multipart/form-data' } };

const uploadsService = {
  uploadPhotoId: (customerId, file) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('customer_id', customerId);
    return apiClient.post('/api/uploads/photo-id', fd, multipart);
  },

  uploadDocument: (customerId, file, documentType = 'general') => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('customer_id', customerId);
    fd.append('document_type', documentType);
    return apiClient.post('/api/uploads/document', fd, multipart);
  },
};

export default uploadsService;
